import type { SelectOption } from '@/shared/types';

import type { TagItem } from '@/entities/tags';
import { updateEntityTags } from '@/entities/tags/api';

export const updateGlossaryTermTags = async (
  glossaryTermId: string,
  newTagFQNs: string[],
  availableTags: SelectOption<string>[],
  currentTags: TagItem[]
): Promise<void> => {
  await updateEntityTags(`/glossaryTerms/${glossaryTermId}`, newTagFQNs, availableTags, currentTags);
};
